<ion-content>
  <div class="login-container">
    <ion-button 
      class="back-btn" 
      ion-button (click)="cancel()" 
      icon-left 
      [ngClass]="{'mounted': !loading}"
    >
      <div class="button-inner">
        <ion-icon name="arrow-back"></ion-icon>
        Back
      </div>
    </ion-button>
    <div class="login-box" [ngClass]="{'loading': loading}">
      <div class="loading-container" *ngIf="loading">
        <ion-spinner></ion-spinner>
        <p>Loading Sign Up...</p>
      </div>
      <div id="clerk-signup" [hidden]="loading"></div>
    </div>
  </div>
  <div class="triangleBg"></div>
</ion-content>